export type BoolString = 'true' | 'false';

export const boolToString = (s: boolean): BoolString => (s ? 'true' : 'false');
export const stringToBool = (s: BoolString) => s === 'true';

export const emptyStringToNull = <T extends unknown>(t: T | ''): T | null => (t === '' ? null : t);
export const emptyBoolStringToNull = (t: BoolString | ''): boolean | null =>
  t === '' ? null : t === 'true';
